import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

@Component({
  selector: 'page-scanner',
  templateUrl: 'scanner.html',
})
export class ScannerPage {

  title:string;
  result: any; 

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private barcodeScanner: BarcodeScanner) {
    this.title = navParams.get('title');
  }

  scan() {
    this.barcodeScanner.scan().then(barcodeData => {
      this.result = barcodeData;
      console.log("BarcodeData: " + barcodeData);
    }).catch(err => {
      this.result = "Error: " + err;
      console.log("Error: " + err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/scanner/scanner.ts